module.exports = __webpack_public_path__ + "img/Rectangle 1187.b52830f5.png";